
import { h, Fragment, render } from 'preact'
import { createPortal } from 'preact/compat'

import { initialSessionFromDom } from './../hooks/useSubmission'
import { useScreen } from './../hooks/useScreen'

import { json } from './../utility/dom'
import { removeQueryHash } from './../utility/url'

import { Screens, requireAdjustmentScreens, eoScreens } from './screens'


export function init() {
	const registerStagesEl = document.getElementById('register-stages-form')
	const session = initialSessionFromDom()
	const stages = json('#form-stages')
	if (!stages || !registerStagesEl) return

	const initialStage = removeQueryHash(window.location.href)
		.replace(stages.apply, '')
		.replace(/^\//, '')
		.replace(/\/$/, '')

	registerStagesEl && render(
		createPortal(<App session={session} initialStage={initialStage} reviewUrl={stages.review} />, registerStagesEl), 
		document.body
	)
}


function App({ session, initialStage, reviewUrl }) {

	const { screen, goTo, goToUrl } = useScreen('EqualOpps1')
	const screens = eoScreens(goTo, goToUrl, reviewUrl)
	
	return <Screens screens={screens} currentScreen={screen} session={session} />
}


